module.exports = __webpack_public_path__ + "img/Mestari-Heittäjä-Eliitti.e76e64c8.png";